import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import NewsletterSignup from './NewsletterSignup';
import { getOptimizedThumbnail, getSsrOptimizedThumbnail, checkAvifSupport } from './frontendUtils.js'; 

const PressReleases = () => {
    const [articles, setArticles] = useState([]); 
    const [optimizedThumbnails, setOptimizedThumbnails] = useState({}); 

    useEffect(() => {
      const fetchPressReleases = async (retries = 3) => {
        try {
          // Step 1: Check for cached press releases
          const cachedPressReleases = sessionStorage.getItem('pressReleases');
          const cachedThumbnails = sessionStorage.getItem('optimizedPressThumbnails');

          if (cachedPressReleases) {
            setArticles(JSON.parse(cachedPressReleases));
            if (cachedThumbnails) {
              setOptimizedThumbnails(JSON.parse(cachedThumbnails));
            }
            return;
          }

          // Step 2: Fetch press releases from API
          const response = await axios.get('/api/category/press release?per_page=6');
          const data = response.data;

          // Step 3: Store raw press releases in session storage
          sessionStorage.setItem('pressReleases', JSON.stringify(data));
          setArticles(data);


          // Step 5: Optimize Thumbnails
          const optimizedMap = {};

          await Promise.all(
            data.map(async (article) => { 
              if (article.thumbnail) {
                try {
                  const optimizedThumb = await getOptimizedThumbnail(article.thumbnail);
                  optimizedMap[article.id] = optimizedThumb;  
                } catch (error) {
                  console.error(`[PressReleases] Error optimizing thumbnail for Article ${article.id}:`, error);
                }
              }
            })
          );

          // Step 6: Store optimized thumbnails in session storage and state
          sessionStorage.setItem('optimizedPressThumbnails', JSON.stringify(optimizedMap));
          setOptimizedThumbnails(optimizedMap);
        } catch (error) {
          //console.error(`Error fetching press releases: ${error}`);
          if (retries > 0) {
            setTimeout(() => fetchPressReleases(retries - 1), 2000);
          }
        }
      };

      fetchPressReleases(); 
    }, []);

    return (
        <div>
            <h1 className="pb-2 mt-2 font-bold text-sm" style={{ fontFamily: 'var(--font-paragraph)' }}> 
                Press Releases
            </h1>
            <div className="grid gap-5 grid-cols-1 md:grid-cols-3">
             {/* Press Releases */}
                <div className="col-span-2 grid grid-cols-2 lg:grid-cols-3 gap-5">
                    {articles.map((article) => (
                        <div
                            key={article.id}
                            className="press-release-item flex flex-col items-start"
                        >
                            <Link to={`/${article.pageUrl}`} className="w-full">
                                <div className="mb-2">
                                    <picture>
                                      {optimizedThumbnails[article.id]?.avifMobile && (
                                        <source
                                          srcSet={optimizedThumbnails[article.id].avifMobile}
                                          type="image/avif"
                                        />
                                      )}
                                      {optimizedThumbnails[article.id]?.webp && (
                                        <source
                                          srcSet={optimizedThumbnails[article.id].webp}
                                          type="image/webp"
                                        />
                                      )}
                                      <img
                                        src={
                                          optimizedThumbnails[article.id]?.fallback ||
                                          optimizedThumbnails[article.id]?.webp ||
                                          article.thumbnail
                                        }
                                        alt={article.title}
                                        width={200}
                                        height={150}
                                        className="object-cover w-[200px] h-[150px]"
                                        style={{
                                          aspectRatio: "4 / 3",
                                        }}
                                      />
                                    </picture>

                                </div>
                                <h2 className="mb-4 font-semibold" style={{fontFamily: 'Arial, Helvetica Neue, Helvetica, sans-serif', color: 'var(--text-color)', fontSize: '16px',lineHeight: '1.35em', fontWeight: '500'}}>
                                    {article.title}
                                </h2>
                            </Link>
                        </div>
                    ))}
                </div>

                {/* Newsletter Subscription */}
                <div className="newsletter-subscription p-5 border border-gray-300 rounded bg-[--bg-color-light]">
                    <h2 className="text-lg font-semibold mb-2">The Trustnodes Daily Newsletter</h2>
                    <p className="text-sm mb-4">Stay updated with the latest news on crypto and stocks.</p>

                    <NewsletterSignup variant="sidebar" />

                    <Link to="/subscription">
                        <img
                            src="https://www.trustnodes.com/wp-content/uploads/2018/10/art-trustnodes-subscribe.png"
                            alt="Subscribe Now"
                            className="w-full mt-8 rounded cursor-pointer"
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PressReleases;
